import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { UserService } from '../core/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { appVariables } from '../app.constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, EventMessage, EventType, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { filter } from 'rxjs/internal/operators/filter';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet *ngIf="canLoadApp"></router-outlet>`
})
export class AppComponent implements OnInit {

  canLoadApp = false;

  isLoggedIn = false;
    username: string | undefined;  

  @HostListener('document:click', ['$event'])
  clickout(event) {
    this.closeAlert();
  }

  //constructor(public msalService: MsalService, private snackBar: MatSnackBar, private userService: UserService, private router: Router) {}
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,private snackBar: MatSnackBar,private userService: UserService,
    private msalBroadcastService: MsalBroadcastService,private route: ActivatedRoute,private router: Router
  ) {}

  
ngOnInit(): void {
  this.msalBroadcastService.msalSubject$
   .pipe(
         filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
       )
      .subscribe((result: EventMessage) => {
     this.isLoggedIn = true;
        });
  
      this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None)
        )
        .subscribe(() => {
          this.isLoggedIn = this.msalService.instance.getAllAccounts().length > 0;
          if (this.isLoggedIn) {
            this.acquireToken();
          }
        });
    }
  
  
 
  
  acquireToken() : void
  {
    var request ={
      scopes:[environment.authScope],
      account: this.msalService.instance.getAllAccounts()[0],
      graphql : [environment.graphQlHost]
    }

    this.msalService.instance.acquireTokenSilent(request).then((tokenResponse:AuthenticationResult) => {
      const name =this.msalService.instance.getAllAccounts()[0]?.name;
      const  username = this.msalService.instance.getAllAccounts()[0]?.username;
      this.userService.currentUserValue.email= username;
      this.userService.currentUserValue.firstName = name;

      if (this.msalService.instance.getAllAccounts()[0]?.username )
        { 
         this.canLoadApp = true;
         this.router.navigate([appVariables.landingPageUrl]);
       }
        else {
        this.canLoadApp = true;
        this.router.navigate([appVariables.unauthorizedPageUrl]);
         }

      })
  }

  
  
closeAlert() 
{
  if (this.snackBar._openedSnackBarRef) {
    this.snackBar.dismiss();
  }
}
}

